// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3dBta","tab":"Tabs_tab__SQvHo","tabActive":"Tabs_tabActive__21BTk"};